import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ScheduleIcon from "@mui/icons-material/Schedule";

/**
 * Last Activity / date column display. Non-pill options:
 * - "inline": small clock icon + formatted date (default)
 * - "minimal": text only, theme-aware
 */
export default function LastActivityCell({ displayText, variant = "inline" }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const hasValue = displayText != null && String(displayText).trim() !== "" && displayText !== "—";
  const text = hasValue ? String(displayText).trim() : "—";

  const textColor = hasValue
    ? isDark
      ? "rgba(226, 232, 240, 0.9)"
      : theme.palette.text.primary
    : isDark
      ? "rgba(255,255,255,0.45)"
      : theme.palette.text.secondary;

  const iconColor = hasValue
    ? isDark
      ? "rgba(148, 163, 184, 0.65)"
      : "rgba(100, 116, 139, 0.7)"
    : textColor;
  const greenColor = theme.palette.success?.main || "#A0C46D";

  if (variant === "minimal") {
    return (
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Box
          component="span"
          sx={{
            fontSize: "0.8125rem",
            fontWeight: 500,
            color: textColor,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            transition: "color 0.2s ease",
            "&:focus-visible": {
              outline: "none",
              boxShadow: `0 0 0 2px ${greenColor}40`,
              borderRadius: "4px",
            },
            "@media (prefers-reduced-motion: reduce)": {
              transition: "none",
            },
          }}
        >
          {text}
        </Box>
      </Box>
    );
  }

  // default: inline (icon + text)
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 0,
        gap: 0.75,
      }}
    >
      <ScheduleIcon
        sx={{
          fontSize: "0.875rem",
          color: iconColor,
          flexShrink: 0,
          mt: "1px",
        }}
      />
      <Box
        component="span"
        sx={{
          fontSize: "0.8125rem",
          fontWeight: 500,
          color: textColor,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: 0,
          transition: "color 0.2s ease",
          "&:focus-visible": {
            outline: "none",
            boxShadow: `0 0 0 2px ${greenColor}40`,
            borderRadius: "4px",
          },
          "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
          },
        }}
      >
        {text}
      </Box>
    </Box>
  );
}
